import { lintSourceConfig } from "components/organisms/manuscript/compile/compileAnnotations";
import { createLinter } from "components/organisms/manuscript/overleaf/visual/linting";
import { latexLinter } from "./linter/latex-linter.js";

export function linting() {
    return createLinter(latexLinter, lintSourceConfig);
}
